import api from '../../plugins/api';

const editLead = (payload) => {
  return api.post('/api/crm/leads/editLead', payload);
};

export default editLead;
